import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, Grid } from "@material-ui/core";
import { read } from "Helpers/LocalStorage";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTheme } from "@material-ui/core/styles";
import * as Icons from "react-bootstrap-icons";
import NewCustomerGroup from "./components/NewCustomerGroup";
import CustomerGroups from "./components/CustomerGroups";

function ManageCustomerGroup() {
  const { direction } = useTheme();
  const [openDialog, setOpenDialog] = useState(false);
  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };
  return (
    <>
      <MuiButton
        color="secondary"
        title={<Translator id="groh_moshtari" />}
        innerIcon={<Icons.People />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        fullWidth
        maxWidth="md"
      >
        <div className="dialogHeader">
          <p>{<Translator id="groh_moshtari" />} </p>
        </div>
        <DialogContent>
          <Grid container spacing={5}>
            {read("groupCustomerRules").accessRegister && (
              <Grid item sm={5} xs={12}>
                <NewCustomerGroup />
              </Grid>
            )}
            <Grid
              item
              sm={read("groupCustomerRules").accessRegister ? 7 : 12}
              xs={12}
            >
              <CustomerGroups />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ManageCustomerGroup;